import { getCookie } from 'src/helpers/queryHelpers'
import { memo, useCallback, useEffect, useMemo } from 'react'

import useLogin from 'src/hooks/useLogin'
import { useRouter } from 'next/router'
import { useCookies } from "react-cookie";

export default memo(function UserProvider({ children }) {
  const { deleteAllCookies, getUserInfo, onSuccessLogin, getRedirectionUrl } = useLogin()
  const { replace, push } = useRouter()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cookies, _, removeCookie] = useCookies()

  const getMe = useCallback(async () => {
    try {
      const Authorization = `${getCookie('vl-accessToken')}`
      const xApiKey = `${getCookie('managementXApiKey')}`
      if (!isValid(Authorization) || !isValid(xApiKey)) return;
      const res = await fetch(`${window.location.origin}/api/auth/verify`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization,
          xApiKey,
        },
      })
      const data = await res.json()
      // const userInfo = await getUserInfo(getCookie('vl-accessToken'));
      // const roles = onSuccessLogin(userInfo);
      // const redirectionUrl = getRedirectionUrl(roles);
      // push(redirectionUrl);
      if (!data.valid) {
        deleteAllCookies()
        replace('/logout')
      }
    } catch (error) {
      return null
    }
  }, [])

  const cloudProvider = useMemo(async () => {
    if (typeof window === 'undefined') return
    const Authorization = `${getCookie('vl-accessToken')}`
    const xApiKey = `${getCookie('managementXApiKey')}`
    if (!isValid(Authorization) || !isValid(xApiKey)) return
    try {
      const res = await fetch(`${window.location.origin}/api/auth/verify/site`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization,
          xApiKey,
        },
      })
      const data = await res.json()
      sessionStorage.setItem('cloudProvider', data.provider)
    } catch (error) {
      return null
    }
  }, [])

  useEffect(() => {
    getMe()
  }, [getMe])

  useEffect(() => {
    cloudProvider
  }, [cloudProvider])

  // this is a temporary block - will be removed in couple months
  // if user has defaultTimezone set as null or undefined, cookie will be removed
  useEffect(() => {
    if (typeof window === 'undefined') return
    const defaultTimezone = cookies?.defaultTimezone
    if (
      defaultTimezone === undefined ||
      defaultTimezone === null ||
      typeof defaultTimezone === 'object' ||
      typeof defaultTimezone === 'undefined' ||
      defaultTimezone === 'null' ||
      defaultTimezone === 'undefined'
    ) {
      removeCookie('defaultTimezone', { path: '/', domain: window?.location?.hostname })
    }
  }, [])

  return <>{children}</>
})

function isValid(value) {
  try {
    return value !== undefined && value !== null && value !== 'null' && value !== 'undefined'
  } catch (e) {
    return false
  }
}
